export enum AddParticipantColumnsEnum {
  STUDENT_NAME = 'Student Name',
  STUDENT_ID = 'Student ID',
  GRADE = 'Grade',
  ROLE = 'Role',
  ACTION = 'Action'
}
